import { Children, isValidElement, useMemo } from 'react';

/**
 * Hook that reorders ColumnChart children so XAxis renders last.
 * This ensures the XAxis baseline appears solid, not covered by other chart elements.
 *
 * XAxis is identified by its displayName property.
 */
export function useColumnChartChildren(children: React.ReactNode): React.ReactNode[] {
  return useMemo(() => {
    const xAxis: React.ReactNode[] = [];
    const others: React.ReactNode[] = [];

    Children.forEach(children, (child) => {
      if (
        isValidElement(child) &&
        typeof child.type === 'function' &&
        (child.type as { displayName?: string }).displayName === 'XAxis'
      ) {
        xAxis.push(child);
      } else {
        others.push(child);
      }
    });

    return [...others, ...xAxis];
  }, [children]);
}
